import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmRoute = _resolveComponent("ConfirmRoute")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", null, "事業所名：" + _toDisplayString(_ctx.office.name), 1),
    _createTextVNode(),
    _createElementVNode("p", null, "事業所担当者名：" + _toDisplayString(_ctx.office.staffName), 1),
    _createTextVNode(),
    _createElementVNode("p", null, [
      _createTextVNode("\n      事業所電話番号：\n      "),
      _createElementVNode("a", {
        class: "text-primary",
        href: 'tel:' + _ctx.office.phoneNumber
      }, _toDisplayString(_ctx.office.phoneNumber), 9, _hoisted_1)
    ]),
    _createTextVNode(),
    _createElementVNode("p", null, "事業所住所：" + _toDisplayString(_ctx.office.address), 1),
    _createTextVNode(),
    _createVNode(_component_ConfirmRoute, {
      latitude: _ctx.office.latitude,
      longitude: _ctx.office.longitude,
      onConfirmRoute: _ctx.confirmOfficeRoute
    }, null, 8, ["latitude", "longitude", "onConfirmRoute"])
  ]))
}